/**
 * @class Logger
 * @classdesc An internal logging utility.
 * @memberof Flightkit
 * @param {Object} opts Initialization options
 * @param {string} opts.mode Verbosity mode to control how granular logging is outputted to the console.
 */
class Logger {
  /**
   * @member {Object} modes Set of available logging verbosity modes.
   * @memberof Flightkit.Logger
   * @static
   * @constant
   * @property {string} VERBOSE (value=`verbose`) defines the most granular level of logging to be outputted into the console for debugging purposes.
   * @property {string} ERRORS (value=`errors`) defines the mode that will only output errors to the console.
   * @property {string} SILENT (value=`silent`) defines the mode that will not output any log to the console.
   */
  static modes = {
    VERBOSE: 'verbose',
    ERRORS: 'errors',
    SILENT: 'silent'
  };
  constructor(opts){
    opts = opts || {};
    /**
     * @instance
     * @memberof Flightkit.Logger
     * @member {string} mode Current logging verbosity mode.
     */
    this.mode = opts.mode || 'errors';
  }
  get prefix(){
    const now = new Date();
    return `[fk-${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}:${now.getMilliseconds()}.${(window?.performance.now().toFixed(2)+'').split('.')[1]}]`;
  }
  log(...args){
    if(this.mode === Logger.modes.SILENT || this.mode !== Logger.modes.VERBOSE){
      return;
    }
    args.unshift(this.prefix);
    console.log.apply(null, args);
  }
  error(...args){
    if(this.mode === Logger.modes.SILENT){
      return;
    }
    args.unshift(this.prefix);
    console.error.apply(null, args);
  }
  warn(...args){
    if(this.mode === Logger.modes.SILENT || this.mode !== Logger.modes.VERBOSE){
      return;
    }
    args.unshift(this.prefix);
    console.warn.apply(null, args);
  }
}

export default Logger;